import * as XLSX from 'xlsx';
import { TranslateService } from "@ngx-translate/core";

import { Driver } from "@commons/models/domain/Driver";
import { ViewWorkers } from '@layout/driver/services/worker.service';
import { driverLicenseToText } from './workers/driver-license-status';

export function exportWorkersToXLS(data: Driver[], viewType: ViewWorkers, translate: TranslateService, fileName = 'data.xlsx') {
  if (!Array.isArray(data) || data.length === 0) {
      console.error("Dane muszą być tablicą obiektów.");
      return;
  }

  const formattedData = data.map(item => {
    const row: any = {
      'Imię': item.FN || '',
      'Nazwisko': item.LN || '',
      'Email': item.Em || '',
      'Numer telefonu': item.CN || ''
    };

    if (viewType === ViewWorkers.Active) {
      row['Prawo jazdy'] = item.L || '-';
      row['Status prawa jazdy'] = driverLicenseToText(item, translate);
    }

    return row;
  });


  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Dane');
  XLSX.writeFile(workbook, fileName);
}
